export default {
  'cookie-banner:title': 'Before you dive back in…',
  'cookie-banner:subtitle':
    'We use cookies to give you the best possible experience. By continuing, you agree to our use of cookies.',
  'cookie-banner:privacy-text':
    'On the { privacyProtectionLink } page, you can read at any time how and for what purpose we use your data.',
  'cookie-banner:privacy-link': 'Privacy Policy',
  'cookie-banner:button': 'Alright, take me to the shop',
};
